__webpack_require__.p = "/mem-skos-vocabs/";